import { Component, Input, InjectionToken, HostBinding, ViewEncapsulation, OnChanges } from '@angular/core';

export const VM_ACCORDION = new InjectionToken<AccordionComponent>('VM_ACCORDION');
@Component({
  selector: 'vm-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  providers: [{ provide: VM_ACCORDION, useExisting: AccordionComponent }],
  encapsulation: ViewEncapsulation.None,
})
export class AccordionComponent {
  @HostBinding('class.vm-accordion') class = true;
  @Input() multi = true;
  @Input() @HostBinding('class.vm-accordion__wide') wideEnable = false;
  @Input() @HostBinding('class.vm-accordion__outer-margins') outerMargins = true;
}
